import { CartResultLineItem } from "entities/cart-result";

export function isFreightOrDelivery(item: CartResultLineItem): boolean {
  return item?.isFreight
    || item?.isCustomerDelivery
    || item?.isRTCDelivery
    || item?.partNumber === 'DELIVERY:90';
}
